import React from 'react';
import { ListItem } from './ListItem';
import { Typography, theme } from '@hiver/hiver-ui-kit';

export default function ActionList(props){
    const { 
        data, 
        title,
        actionText,
        icon,
        onAction,
        listStyle='',
        listHeaderStyle,
        listItemStyle,
        variant,
        isLoading,
        onSettingsToggle,
        showToggle=true,
        sliderProps={},
        ...rest
    } = props;
    const list = data.map(({key, data, children:Children,hasError, upgradePlan,subItemActive, isExploringHigherPlan, upgradeClickedEvent }) => (  
            <ListItem 
                    id={key}
                    key={`action-list-item-${key}`}
                    actionText={actionText} 
                    data={data}
                    icon={icon}
                    onAction={onAction}
                    variant={variant}
                    listItemStyle={listItemStyle}
                    isLoading={isLoading}
                    onSettingsToggle={onSettingsToggle}
                    hasError={hasError}
                    subItemActive={subItemActive}
                    upgradePlan={upgradePlan}
                    upgradeClickedEvent={upgradeClickedEvent}
                    showToggle={showToggle}
                    sliderProps={sliderProps}
                    isExploringHigherPlan={isExploringHigherPlan}
                >
                    {
                    Children ?
                    (props) => <Children {...props} /> 
                    :null
                     }
            </ListItem>
            ));
    return (
        <div className={listStyle} {...rest}>
            { (list.length > 0) && title && <div className={ listHeaderStyle + " h-h2" }>
                    <Typography variant="h3" style={{ color: theme.palette.gray.black }}>
                        {title}
                    </Typography>
                </div>
            }
            <div>
                {list}
            </div>
        </div>
    )
}

export {
    ActionList
}